export default __webpack_public_path__ + "static/media/movi_banner_graph.566d0673.png";